import { API_URL } from '@/services/api';
/**
 * Utility functions for URL handling
 */

/**
 * Converts a relative API path to an absolute URL.
 * Handles both relative paths (starting with /) and already-absolute URLs.
 *
 * @param path - The path or URL to convert
 * @returns The absolute URL, or the original value if null/undefined
 */
export function toApiUrl(path: string | null | undefined): string | null {
  if (!path) return null;

  // Already absolute URL
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  // Ensure path starts with / for proper concatenation
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  // Relative path - prepend API URL
  return `${API_URL}${normalizedPath}`;
}

/**
 * Converts a relative API image path to an absolute URL for use in img src.
 * Returns undefined instead of null for easier use with optional img src.
 *
 * @param path - The path or URL to convert
 * @returns The absolute URL, or undefined if null/undefined
 */
export function toApiImageUrl(path: string | null | undefined): string | undefined {
  const url = toApiUrl(path);
  return url || undefined;
}
